import { CYSILL_SEARCH_SUCCESS, CYSILL_SEARCH_HAS_ERRORED } from './types';
import { FEED_URLSRC_CYSILL, CYSILL_ACCESS_KEY, CYSILL_MAX_ERRORS } from '../constants'
import { globalFetch } from './globalActions';

////////////////////////
// EMAIL VERIFICATION //
////////////////////////


export function clearCysillCheck() {
    return function(dispatch) {
        dispatch({ type: CYSILL_SEARCH_SUCCESS, payload: {}}); 
    }
}

export function cysillCheck(string) {
	return globalFetch({
            urlSrc: FEED_URLSRC_CYSILL,
            extraParams: `?api_key=${CYSILL_ACCESS_KEY}&max_errors=${CYSILL_MAX_ERRORS}&text=${encodeURIComponent(string)}`,
			reducerError: CYSILL_SEARCH_HAS_ERRORED,
			dispatchSuccess: (itemObj, dispatch) => {
                dispatch({ type: CYSILL_SEARCH_SUCCESS, payload: itemObj}); 
			}
	});
}